<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="6" md="5" sm="6" cols="12">
          <v-card
            class="deposit-form"
            :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
          >
            <v-row>

              <!-- ================= BEFORE OTP ================= -->
              <template v-if="!mamWalletWithdrawDetails?.otpsent">

                <!-- WITHDRAW METHOD -->
                <v-col cols="12">
                  <fieldset>
                    <legend>Withdraw Method</legend>
                    <v-select
                      v-model="withdrawMethod"
                      :items="withdrawMethods"
                      solo
                      append-icon="mdi-chevron-down"
                      label="Select Method"
                      class="custom-select"
                      hide-details
                    />
                  </fieldset>
                </v-col>

                <!-- FROM WALLET -->
                <v-col cols="12">
                  <fieldset>
                    <legend>MAM Transfer From</legend>
                    <v-select
                      solo
                      :items="fromFormattedAccounts"
                      item-value="id"
                      item-text="displayText"
                      append-icon="mdi-chevron-down"
                      label="Select Wallet"
                      class="custom-select"
                      hide-details
                      @change="fromAccountSelected"
                    />
                  </fieldset>
                  <span v-if="error.fromAccountError" class="error-message">
                    {{ error.fromAccountError }}
                  </span>
                </v-col>

                <!-- CRYPTO ADDRESS -->
                <v-col v-if="withdrawMethod === 'Crypto'" cols="12">
                  <fieldset>
                    <legend>To Your Crypto Address</legend>
                    <v-select
                      v-model="wallet_address"
                      :items="addresses"
                      item-text="renamedAddress"
                      item-value="address"
                      solo
                      append-icon="mdi-chevron-down"
                      label="Select Crypto Address"
                      class="custom-select"
                      hide-details
                    />
                  </fieldset>
                </v-col>

                <!-- BANK FIELDS -->
                <template v-if="withdrawMethod === 'Bank'">
                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Bank Name</legend>
                      <v-select
                        v-model="selectedBank"
                        :items="banks"
                        item-text="bank_name"
                        item-value="id"
                        solo
                        append-icon="mdi-chevron-down"
                        class="custom-select"
                        hide-details
                        @change="handleBankChange"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Bank Account No.</legend>
                      <v-text-field
                        v-model="bankAccountNumber"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Account Name</legend>
                      <v-text-field
                        v-model="bankAccountName"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>IFSC / Swift</legend>
                      <v-text-field
                        v-model="bankSwiftNum"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12">
                    <fieldset>
                      <legend>Bank Address</legend>
                      <v-text-field
                        v-model="bankAddress"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>
                </template>

                <!-- AMOUNT -->
                <v-col cols="12">
                  <fieldset>
                    <legend>Amount (USD)</legend>
                    <v-text-field
                      v-model="amount"
                      type="number"
                      min="1"
                      solo
                      hide-details
                      class="custom-select"
                    />
                  </fieldset>
                  <span v-if="error.amount_error" class="error-message">
                    {{ error.amount_error }}
                  </span>
                </v-col>

                <!-- SEND OTP -->
                <v-col cols="12">
                  <v-btn
                    @click.prevent="handleForm"
                    :loading="loading"
                    tile
                    class="btn-account d-block w-100"
                    color="greenMain"
                  >
                    Send OTP
                  </v-btn>
                </v-col>

              </template>

              <!-- ================= OTP ONLY ================= -->
              <template v-else>

                <v-col cols="12">
                  <fieldset>
                    <legend>Enter OTP Code</legend>
                    <v-text-field
                      v-model="verifiedCode"
                      type="number"
                      solo
                      hide-details
                      class="custom-select"
                      @input="limitDigits"
                    />
                  </fieldset>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    @click.prevent="submitForm"
                    :loading="loading2"
                    tile
                    class="btn-account d-block w-100"
                    color="greenMain"
                  >
                    Submit
                  </v-btn>
                </v-col>

              </template>

            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>


<script>
import { mapActions, mapState } from "vuex";
import {
  MAM__WALLET__ACTIONS,
  WITHDRAWMETHODS__ACTIONS,
} from "@/store/action-types";

export default {
  data() {
    return {
      withdrawMethod: "Crypto",
      withdrawMethods: ["Crypto", "Bank"],

      fromAccount: null,
      amount: null,

      wallet_address: null,
      network: "",

      selectedBank: null,
      bankAccountNumber: "",
      bankAccountName: "",
      bankSwiftNum: "",
      bankAddress: "",

      verifiedCode: null,
      loading: false,
      loading2: false,

      error: {
        fromAccountError: null,
        amount_error: null,
        wallet_address: false,
      },
    };
  },

  computed: {
    ...mapState("withdraw", ["addresses", "banks"]),
    ...mapState("mamWallet", [
      "mam_wallet_summary",
      "mamWalletWithdrawDetails",
    ]),

    fromFormattedAccounts() {
    const w = this.mam_wallet_summary?.mamWalletHistory;

    return [
      {
        id: "manager",
        displayText: `Manager Wallet: ${Number(
          w?.manager_available_balance || 0
        ).toFixed(2)} USD`,
      },
      {
        id: "investor",
        displayText: `Investor Wallet: ${Number(
          w?.investor_available_balance || 0
        ).toFixed(2)} USD`,
      },
    ];
  }
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS,
      WITHDRAWMETHODS__ACTIONS.BROKERSBANK,
    ]),
    ...mapActions("mamWallet", [
      MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY,
      MAM__WALLET__ACTIONS.MAMWALLETWITHDRAWCODE,
      MAM__WALLET__ACTIONS.CONFIRMMAMWALLETWITHDRAW,
    ]),

    fromAccountSelected(type) {
      const w = this.mam_wallet_summary.mamWalletHistory;
      this.fromAccount = {
        type,
        Balance:
          type === "manager"
            ? Number(w.manager_available_balance)
            : Number(w.investor_available_balance),
      };
      this.error.fromAccountError = null;
    },

    handleWalletAddress() {
      const addr = this.addresses.find(
        (a) => a.address === this.wallet_address
      );
      this.network = addr?.network || "";
      this.error.wallet_address = false;
    },

    handleBankChange() {
      const b = this.banks.find((x) => x.id === this.selectedBank);
      if (!b) return;
      this.bankAccountNumber = b.bank_acc_num;
      this.bankAccountName = b.bank_acc_name;
      this.bankSwiftNum = b.bank_swift_num;
      this.bankAddress = b.bank_address;
    },

    async handleForm() {
      this.error.fromAccountError = null;
      this.error.amount_error = null;
      this.error.wallet_address = false;

      if (!this.fromAccount) {
        this.error.fromAccountError = "Please select a wallet";
        return;
      }

      const amount = Number(this.amount);
      const availableBalance = Number(this.fromAccount.Balance);

      if (!amount || isNaN(amount)) {
        this.error.amount_error = "Please enter a valid amount";
        return;
      }

      if (amount <= 0) {
        this.error.amount_error = "Amount must be greater than 0";
        return;
      }

      if (amount > availableBalance) {
        this.error.amount_error = `Insufficient balance. Available: ${availableBalance.toFixed(
          2
        )} USD`;
        return;
      }

      if (this.withdrawMethod === "Crypto" && !this.wallet_address) {
        this.error.wallet_address = true;
        return;
      }

      this.loading = true;
      try {
        await this[MAM__WALLET__ACTIONS.MAMWALLETWITHDRAWCODE]({
          amount,
          wallet_type: this.fromAccount.type,
          withdraw_method: this.withdrawMethod,
          wallet_address:
            this.withdrawMethod === "Crypto" ? this.wallet_address : null,
          network: this.withdrawMethod === "Crypto" ? this.network : null,
          bank_id: this.withdrawMethod === "Bank" ? this.selectedBank : null,
        });
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.loading2 = true;
      try {
        await this[MAM__WALLET__ACTIONS.CONFIRMMAMWALLETWITHDRAW]({
          code: this.verifiedCode,
        });
      } finally {
        this.loading2 = false;
      }
    },

    limitDigits() {
      if (this.verifiedCode?.length > 6) {
        this.verifiedCode = this.verifiedCode.slice(0, 6);
      }
    },
  },

  async mounted() {
    await this[WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS]();
    await this[WITHDRAWMETHODS__ACTIONS.BROKERSBANK]();
    await this[MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]();
  },
};
</script>

<style scoped>
.error-message {
  color: #ff567f;
  font-size: 13px;
}
</style>
